import _ from 'lodash'
import { all, put, select, take, takeEvery } from 'redux-saga/effects'

import { TABS_ADD_TAB, TABS_REMOVE_TAB, TABS_ACTIVE_TAB } from './constants'

import { activeTab, newTabAdded, tabRemoved, tabActivated } from './actions'
import { setActiveModule } from '../../../../services/routing/actions'

import { getActiveModule, hasModuleLoadedAccessRights, tabsSelector } from './selectors'
import { createLoadModuleAccessRightAction } from '../../../../services/authorization/helpers'

function* addTabSaga(_action) {
    const tabId = _.get(_action, 'data.id', null)
    const tabType = _.get(_action, 'data.type', null)

    const activeModuleKey = yield select(getActiveModule)
    if (activeModuleKey !== tabType) {
        yield put(setActiveModule(tabType))
    }

    // wait for module access rights, if aren't loaded
    const loadedAccessRights = yield select(hasModuleLoadedAccessRights, tabType)
    if (!loadedAccessRights) {
        yield all([
            take(`SET_${_.toUpper(tabType)}_MODULE_ACCESS_RIGHTS`),
            put(createLoadModuleAccessRightAction(tabType)),
        ])
    }

    yield put(activeTab(tabId, tabType))

    yield put(newTabAdded(tabId, tabType))

    return null
}

function* removeTabSaga(_action) {
    const tabId = _.get(_action, 'data.id', null)
    const tabType = _.get(_action, 'data.type', null)

    // tabs without remove tab (reducer before saga)
    const actualTabs = yield select(tabsSelector)

    // if need, active tab
    const hasActiveTab = !!actualTabs.find((tab) => tab.get('active'))
    if (!hasActiveTab) {
        const newActiveTab = actualTabs.findLast((tab) => tab.get('type') === tabType) || actualTabs.last() || null

        if (newActiveTab) yield put(activeTab(newActiveTab.get('id'), newActiveTab.get('type')))
    }

    yield put(tabRemoved(tabId, tabType))

    return null
}

function* activeTabSaga(_action) {
    const tabId = _.get(_action, 'data.id', null)
    const tabType = _.get(_action, 'data.type', null)

    const activeModuleKey = yield select(getActiveModule)
    if (activeModuleKey !== tabType) {
        yield put(setActiveModule(tabType))
    }

    yield put(tabActivated(tabId, tabType))

    return null
}

export default function* tabsSaga() {
    yield all([
        yield takeEvery(TABS_ADD_TAB, addTabSaga),
        yield takeEvery(TABS_REMOVE_TAB, removeTabSaga),
        yield takeEvery(TABS_ACTIVE_TAB, activeTabSaga),
    ])
}
